import { Button, Tooltip } from '@grupoboticario/flora-react';
import { FiDownload } from 'react-icons/fi';
import { useEffect, useState } from 'react';
import { downloadAllReports, getReportsUrls } from 'utils/downloadUrls';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';

export interface CertificateWrapperProps {
  selected: string[];
  franshiceCode: any;
}

export const DownloadMultipleButton = ({
  selected,
  franshiceCode,
}: CertificateWrapperProps) => {
  const { cpId } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );
  const [showDownloadButton, setShowDownloadButton] = useState(true);

  async function handleDownloadAll() {
    try {
      const files = await getReportsUrls(
        cpId,
        JSON.stringify(franshiceCode),
        selected,
      );
      await downloadAllReports(files);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (selected.length > 0) {
      setShowDownloadButton(false);
    } else {
      setShowDownloadButton(true);
    }
  }, [selected]);

  return (
    <div>
      <Tooltip
        align="center"
        direction="top"
        showArrow
        size="standard"
        text="Baixar todos os relatórios selecionadas"
      >
        <Button
          aria-label="Botão de download"
          hierarchy="primary"
          disabled={showDownloadButton}
          onClick={handleDownloadAll}
        >
          <FiDownload size={18} />
        </Button>
      </Tooltip>
    </div>
  );
};
